export default {
  fontSize: '0.85rem',
  extraCarouselInsetWithoutBottomServiceMode: 0,
};
